import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">THINKING LATERALLY</span>
                                            </div>
                                            <p>We all solve problems every day or, at least, find ways round
                                                them. Mostly, we deal with things well
                                                enough, but how often have you felt there must be another
                                                way – just what or how, exactly? This
                                                is where lateral thinking comes in and it’s a useful skill
                                                because, if you always think about things
                                                in the same way you could be missing the point, and much
                                                else besides. Lateral thinking is all
                                                about considering things from different perspectives and in
                                                less habitual ways. It can eliminate
                                                potential blind spots, produce alternative solutions,
                                                identify otherwise hidden opportunities and
                                                improve existing processes and methodologies.</p>
                                            <p>Recognising that we all think differently from one another is
                                                the first step towards lateral thinking.
                                                There are a range of different problems and some insights
                                                about different personal preferences<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a>&nbsp;&nbsp;that
                                                will help you to reflect on your own ability to think
                                                laterally.</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">LATERAL THINKING PROBLEMS</span>
                                            </div>
                                            <p>Here are a few briefly described scenes to help you recognise
                                                your own thinking habits and start
                                                you thinking ‘outside the box’. Consider the examples
                                                below<a className="superscripttext"
                                                        href="further_info.php?course=300"><sup>3</sup></a> and
                                                see whether you can think of
                                                the solutions. The answers are given at the end of this tool
                                                – but don’t peek, just work through
                                                the exercise – it’ll be worth it! Write your solutions in
                                                the boxes below the examples.</p>
                                            <div className="border_subtitle">Example one</div>
                                            <p>Acting on an anonymous phone call, police raid a house to
                                                arrest a suspected murderer. They
                                                don’t know what he looks like, but they know his name is
                                                John and that he’s inside the house.
                                                They burst in on a carpenter, a lorry driver, a mechanic and
                                                a fireman, all playing poker. Without
                                                hesitation or communication of any kind, they immediately
                                                arrest the fireman. How do they know
                                                they’ve got their man?</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve green_curve1">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="center"
                                                        className="lightgreen">
                                                        <textarea className="curved_textarea"
                                                                  rows="5"
                                                                  cols="100"
                                                                  name="textareaExempleOne"
                                                                  value={this.props.pageData?.textareaExempleOne}
                                                                  onChange={this.props.handleChangePageData}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="border_subtitle">Example two</div>
                                            <p>A recluse who never left home was only visited when his food
                                                and other supplies were delivered
                                                and even then, no one went inside. One stormy, winter’s
                                                night when a gale was blowing, he had
                                                what the locals later decided must have been a nervous
                                                breakdown, because he went upstairs,
                                                turned off all the lights and went to bed. Next morning, he
                                                had caused the deaths of several
                                                hundred people. How?</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve green_curve1">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="center"
                                                        className="lightgreen">
                                                                     <textarea className="curved_textarea"
                                                                               rows="5"
                                                                               cols="100"
                                                                               name="textareaExempleTwo"
                                                                               value={this.props.pageData?.textareaExempleTwo}
                                                                               onChange={this.props.handleChangePageData}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}